module.exports = __webpack_public_path__ + "static/media/fav.fb2e6910.svg";